// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { createEntityAdapter } from '@reduxjs/toolkit';
import type {
  TagEntity,
  TagAssignmentEntity,
  TagsManagementState,
} from '@shared/data-access/interfaces/redux/tags-management-state-types';

export const tagsAdapter = createEntityAdapter<TagEntity, number>({
  selectId: tag => tag.tag_id,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

export function generateAssignmentId(objectType: string, objectId: string): string {
  return `${objectType}:${objectId}`;
}

export const assignmentsAdapter = createEntityAdapter<TagAssignmentEntity, string>({
  selectId: a => generateAssignmentId(a.object_type, a.object_id),
  sortComparer: (a, b) =>
    generateAssignmentId(a.object_type, a.object_id).localeCompare(
      generateAssignmentId(b.object_type, b.object_id),
    ),
});

export const initialState: TagsManagementState = {
  tags: tagsAdapter.getInitialState(),
  assignments: assignmentsAdapter.getInitialState(),
};
